module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julia Knight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Julia Knight")]), _vm._v(" is married with two children and the world's daftest dog. She lives in Sussex, UK and when not writing she likes motorbikes, watching wrestling and exploring new ways to get a giggle out of life. Julia is a member of the T Party writers' group.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4PYMBw/images/9780316374996.jpg?1733067579285",
      "alt": "This image is the cover for the book Legends and Liars, The Duelists Trilogy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Legends and Liars, The Duelists Trilogy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("Legends and Liars")]), _vm._v(" is the second book in the Duelist's trilogy -- a fast-paced adventure from one of the most exciting new talents in fantasy.")]), _c('br'), _c('b', [_c('br'), _vm._v("Vocho and Kacha are brother and sister, and between them they've got quite a reputation. They were once know for the finest swordplay in the city of Reyes. The only problem is, ever since they were thrown out of the Duelist's Guild for accidentally killing a man they were sworn to protect, it seems everyone wants them dead. Including a dark magician whose plans they recently thwarted. . ."), _c('br'), _c('br'), _vm._v("Now Vocho and Kacha are in the midst of an uneasy truce, not sure whether to trust each other, or anyone else for that matter. What's more, the sinister magician is rumored to have returned. Now he knows who was behind the failure of his last plan, he's determined to put a stop to Vocho and Kacha permanently."), _c('br'), _c('br'), _vm._v("And this time, the flash of steel may not be enough to save them.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Orbit / Yen\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0